__turbopack_context__.v({
  "cellGrowLoading": "k5Bj1W_cellGrowLoading",
  "cellWithSubtitleLoading": "k5Bj1W_cellWithSubtitleLoading",
  "processingMobile": "k5Bj1W_processingMobile",
});
